// extracted by mini-css-extract-plugin
export default {"IconChange":"SideBar_IconChange__Gj-q+","UserName":"SideBar_UserName__-cdT9"};